import { IDiscountRequest, DiscountRequest } from './discount-request';

export interface IProjectIncentiveEditingModel {
    taxExemptionFormUrl: string;
    discounts: IDiscountRequest[];
}


export class ProjectIncentiveEditingModel implements IProjectIncentiveEditingModel {
    public taxExemptionFormUrl: string = '';
    public discounts: IDiscountRequest[] = [];
}


